import { GET_USER_LIST } from 'modules/user/graphql/queries/user';
import { apolloClient } from 'providers/graphql';

import { isUsersCacheActual, saveUsersToCache } from '../user-cache';

export const refreshUsersCacheIfExpired = async () => {
  if (isUsersCacheActual()) {
    return;
  }
  const { data } = await apolloClient.query({
    query: GET_USER_LIST,
    variables: {
      input: { filter: { roles: ['Admin', 'CollectionTeam'] }, take: 10 },
    },
    fetchPolicy: 'network-only',
  });
  saveUsersToCache(data.getUsersList.data);
};
